const TaskItemsCardType = {
    TO_MOVE: 0,
    IN_INVENTORY: 1,
    MOVED: 2,
    PRESENT: 3,
    ASSIGNMENT: 4
};

export {TaskItemsCardType};
